const handleClick = () => {
    window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
    });
}

export default function (el) {
    el.addEventListener("click", handleClick);
}